import React from 'react';

import { api } from '../../../../../core/api';
import { BenchmarkView } from '../../../../../generated/model/benchmarkView';
import CompanyTabContent from '../shared/CompanyTabContent';
import { consolidationToggleState } from '../shared/companyTabs.utils';
import ConsolidationToggle from '../shared/ConsolidationToggle/ConsolidationToggle';
import { useConsolidationToggleStorage } from '../shared/ConsolidationToggle/useConsolidationToggleStorage';
import { useCompanyFinTabLoader } from '../shared/useCompanyTabLoader';
import GeneralRatios from './GeneralRatios';
import LiquidityRatios from './LiquidityRatios';
import ProfitabilityRatios from './ProfitabilityRatios';
import TPSpecificRatios from './TPSpecificRatios';

interface Props {
  consolidationPreference?: BenchmarkView.ConsolidationPreferenceEnum;
}
const CompanyRatios: React.FC<Props> = ({ consolidationPreference }) => {
  const { data, isLoading } = useCompanyFinTabLoader(api.company.getRatiosData);
  const { toggleValue, onToggleChange } = useConsolidationToggleStorage();

  function hasOfConsolidationType(consolidation: boolean) {
    return (
      (data?.generalRatios?.some((d) => d.consolidation === consolidation) ?? false) ||
      (data?.profitabilityRatios?.some((d) => d.consolidation === consolidation) ?? false) ||
      (data?.specificRatios?.some((d) => d.consolidation === consolidation) ?? false) ||
      (data?.liquidityRatios?.some((d) => d.consolidation === consolidation) ?? false)
    );
  }
  const hasConsolidated = hasOfConsolidationType(true);
  const hasUnconsolidated = hasOfConsolidationType(false);
  const { showConsolidationToggle, consolidation } = consolidationToggleState(
    hasConsolidated,
    hasUnconsolidated,
    consolidationPreference,
    toggleValue,
  );

  return (
    <CompanyTabContent isLoading={isLoading}>
      {showConsolidationToggle && (
        <ConsolidationToggle toggleValue={toggleValue} onToggleChange={onToggleChange} />
      )}
      <GeneralRatios
        data={data?.generalRatios?.filter((d) => d.consolidation === consolidation)}
        ccy={data?.currency}
      />
      <ProfitabilityRatios
        data={data?.profitabilityRatios?.filter((d) => d.consolidation === consolidation)}
        ccy={data?.currency}
      />
      <TPSpecificRatios
        data={data?.specificRatios?.filter((d) => d.consolidation === consolidation)}
        ccy={data?.currency}
      />
      <LiquidityRatios
        data={data?.liquidityRatios?.filter((d) => d.consolidation === consolidation)}
        ccy={data?.currency}
      />
    </CompanyTabContent>
  );
};

export default CompanyRatios;
